/* eslint-disable */

import Isotope from 'isotope-layout';
require('isotope-masonry-horizontal');
window.Isotope = Isotope;

/* eslint-enable */
